module.exports = __webpack_public_path__ + "static/media/mouth.5cc5bcc7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moonsflow/mouth.svg
// module id = 643
// module chunks = 0